import type { TOC } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import GeneralEmbeddedApp from 'lumen/components/general/embedded-app';
import type MarketSegmentDrilldownController from 'lumen/controllers/market/segment-drilldown';
import getEnv from 'lumen/helpers/get-env';

interface MarketSegmentDrilldownSignature {
  Args: {
    controller: MarketSegmentDrilldownController;
    model: unknown;
  };
}

<template>
  <GeneralEmbeddedApp
    {{! @glint-expect-error: Incorrect type }}
    @baseURL={{getEnv "spiderIframeURL"}}
    @id="spider-portfolios"
    @query={{@controller.extendedQueryParams}}
    @url={{if
      @controller.hotelAndMarketService.isMyHotels
      "/dashboards/executive/segment-drilldown"
      (concat
        "/dashboards/portfolio-snapshot/"
        @controller.model.id
        "/segment-drilldown"
      )
    }}
  />
</template> satisfies TOC<MarketSegmentDrilldownSignature>;
